import { computed, Injectable, signal } from '@angular/core';
import { IBreadcrumb } from '@app/features/document-control/models/document.model';
import { MsBreadcrumbItem } from '@Mobilesentrix/ms-design-system';
import { assetUrl } from '@app/shared/utils/asset-url';

@Injectable({ providedIn: 'root' })
export class VariableService {
    isUserInDriveModule = signal(false);
    currentParentId = signal<string | null>(null);
    breadcrumbs = signal<IBreadcrumb[]>([]);
    fileDownLoading = signal<Map<string, boolean>>(new Map());
    breadcrumbItems = computed<MsBreadcrumbItem[]>(() => [
        { label: 'Root', icon: 'home' },
        ...this.breadcrumbs().map(b => ({ label: b.name })),
    ]);

    sharedWithMeCurrentParentId = signal<string | null>(null);
    sharedWithMeBreadcrumbs = signal<IBreadcrumb[]>([]);
    sharedWithMeBreadcrumbItems = computed<MsBreadcrumbItem[]>(() => [
        { label: 'Root', icon: 'home' },
        ...this.sharedWithMeBreadcrumbs().map(b => ({ label: b.name })),
    ]);

    updateLoaderMap(fileIds: string | string[]) {
        const ele = Array.isArray(fileIds) ? fileIds : [fileIds];
        ele?.forEach(fileId => {
            this.fileDownLoading.update(prev => {
                const map = new Map(prev);
                map.set(fileId, true);
                return map;
            });
        });
    }

    removeKeyMap(fileIds: string | string[]) {
        const ele = Array.isArray(fileIds) ? fileIds : [fileIds];
        ele?.forEach(fileId => {
            this.fileDownLoading.update(prev => {
                const map = new Map(prev);
                map.delete(fileId);
                return map;
            });
        });
    }

    setIsUserInDriveModule(value: boolean) {

        this.isUserInDriveModule.set(value);
        if (!value) {
            this.breadcrumbs.set([]);
            this.currentParentId.set(null);
            this.sharedWithMeBreadcrumbs.set([]);
            this.sharedWithMeCurrentParentId.set(null);
        }
    }

    setIsUserBreadCrumb(value: boolean) {
        if (!value) {
            this.breadcrumbs.set([]);
            this.currentParentId.set(null);
        }
    }

    setIsUserSharedWIthMenBreadCrumb(value: boolean) {
        if (!value) {
            this.sharedWithMeBreadcrumbs.set([]);
            this.sharedWithMeCurrentParentId.set(null);
        }
    }

    getExtensionFromUrl(url: string | undefined): string {
        if (!url) return '';
        return url.split('.').pop()?.toLowerCase() ?? '';
    }


    //for files url

    getFileIconPath(extOrUrl: string | undefined): string {
        if (!extOrUrl) return assetUrl('assets/icons/svg/document-icons/file-text.svg');
        const raw = extOrUrl.replace('.', '').split('.').pop()?.toLowerCase() ?? extOrUrl.replace('.', '').toLowerCase();
        const supported = ['pdf', 'csv', 'xlsx', 'xls', 'docx', 'doc', 'pptx', 'ppt', 'mp4', 'jpg', 'jpeg', 'png', 'txt'];
        return supported.includes(raw)
            ? assetUrl(`assets/icons/svg/document-icons/${raw}.svg`)
            : assetUrl('assets/icons/svg/document-icons/file-text.svg');
    }

}
